module.exports = __webpack_public_path__ + "img/bulletin-board.3ab638f0.svg";